import React from 'react';
import bannerImage from "..//img/aaaservices/banner 7-04-25[1].jpg";
import brochure from '../img/TOOL & FIXURE DESIGN BROCHURE V3.pdf';
import Digitalkey from'./Digitalkey';
import ModuleFactory from'./ModuleFactory';
import Digitalwhyshudattand from'./Digitalwhyshudattand';
import Whatwillgaindigital from'./Whatwillgaindigital';
import Whowasattanddigital from'./Whowastoattandtool';
import ToolCoveredImgesVR from'./ToolCoveredImgesVR';
import Keyfeaturebannerdigital from './Keyfeaturebannerdigital';
import Enach from './Enach';

const Outdoor = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = brochure;
    link.download = 'Brochure.pdf';
    link.click();
  };

  const handleEnquiry = () => {
    console.log("Enquiry button clicked");
  };

  return (
    <div>
      {/* Banner Image */}
      {/* <div>
        <img
          src={bannerImage}
          alt="Banner"
          style={{ width: '100%', height: 'auto', maxHeight: '650px', objectFit: 'cover' }}
        />
      </div> */}

      {/* <PCMobileApplications /> */}
      {/* <Enach/> */}
<Keyfeaturebannerdigital/>
      {/* <Digitalkey/> */}
                <ModuleFactory/>
                {/* <LearningPathDommy /> */}
                <Digitalwhyshudattand />
                <Whatwillgaindigital />
                <Whowasattanddigital />
                <ToolCoveredImgesVR />
                {/* <ToolCoveredImgesVR /> */}
    </div>
  );
};

export default Outdoor;
